export const getImageName = (img) =>
  img?.name || "Untitled";

export const getExtension = (img) =>
  img?.name?.includes(".")
    ? img.name.split(".").pop()
    : "-";

export const getFileSize = (img) => {
  const size = img?.meta?.size;
  if (!size && size !== 0) return "Unknown size";

  const kb = size / 1024;
  return kb < 1024
    ? `${Math.round(kb)} KB`
    : `${(kb / 1024).toFixed(2)} MB`;
};

export const getDimensions = (img) =>
  img?.meta?.width && img?.meta?.height
    ? `${img.meta.width} x ${img.meta.height}`
    : "_ x _";

export const getUploadDate = (img) =>
  img?.meta?.createdAt
    ? new Date(img.meta.createdAt).toLocaleDateString(undefined, {
        year: "numeric",
        month: "long",
        day: "numeric",
      })
    : "Not available";

